import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBUserInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import * as selectors from 'app/selectors';
import { api } from 'app/services';
import { FIX_GROUP } from 'app/constants/hint';

var GroupSettingManageForm = class extends React.Component {constructor(props) {super(props);this.state = { users: [], loadingUsers: false, usersError: null };this.setLocation = this.setLocation.bind(this);this.loadUsers = this.loadUsers.bind(this);this.handleUserSearch = this.handleUserSearch.bind(this);this.retryLoadUsers = this.retryLoadUsers.bind(this);this.searchTimer = null;this.requestId = 0;}componentDidMount() {this.loadUsers('');}componentDidUpdate(prevProps) {if (prevProps.loc_id !== this.props.loc_id) this.loadUsers('');}componentWillUnmount() {this.requestId += 1;if (this.searchTimer) clearTimeout(this.searchTimer);}loadUsers(q) {
    const requestId = ++this.requestId;
    this.setState({ loadingUsers: true, usersError: null });
    return api.getGroupRoleCandidates(this.props.loc_id, q ? { q } : {}).then(json => {
      if (requestId !== this.requestId) return;
      const users = json && (json.json || json.response && (json.response.body || json.response.data)) || [];
      this.setState({ users: Array.isArray(users) ? users : [], loadingUsers: false });
    }, error => {
      if (requestId !== this.requestId) return;
      this.setState({ loadingUsers: false, usersError: error });
    });
  }handleUserSearch(q) {
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadUsers((q || '').trim()), 300);
  }retryLoadUsers() {this.loadUsers('');}setLocation(
  model) {
    const { updateGroupRoles } = this.props;
    const { operator_ids, manager_id, content_ids } = model;
    return updateGroupRoles({ roles: [
      {
        role: 'location_group_wechat_manager',
        user_ids: manager_id ? manager_id.split(',').map(Number) : [] },

      {
        role: 'location_group_operator',
        user_ids: operator_ids ? operator_ids.split(',').map(Number) : [] },

      {
        role: 'location_group_content_manager',
        user_ids: content_ids ? content_ids.split(',').map(Number) : [] }] });



  }render()
  {
    const {
      fields: { operator_ids, manager_id, content_ids },
      error,
      submitting,
      handleSubmit,
      manager,
      operators,
      contentManager } =
    this.props;
    const { users, loadingUsers, usersError } = this.state;
    const hint = FIX_GROUP;
    return (
      <form onSubmit={handleSubmit(this.setLocation)}>
        <div>
          <p style={{ color: '#c8c8c8', fontSize: 12, marginBottom: 20 }}>
            {hint.manage_team}
          </p>
          <div className="kb-row">
            <Field name="operator_ids" component={renderKBUserInput}
            title="项目负责人"
            className="kb-form-group kb-form-c18 kb-form-alone"
            hint={hint.staff}

            multi={true}
            users={users}
            onInputChange={this.handleUserSearch}
            selectedUsers={operators} />

          </div>
          <div className="kb-row">
            <Field name="manager_id" component={renderKBUserInput}
            title="项目活动负责人"
            className="kb-form-group kb-form-c18 kb-form-alone"

            multi={true}
            users={users}
            onInputChange={this.handleUserSearch}
            selectedUsers={manager} />

          </div>
          <div className="kb-row">
            <Field name="content_ids" component={renderKBUserInput}
            title="项目内容管理员"
            className="kb-form-group kb-form-c18 kb-form-alone"

            multi={true}
            users={users}
            onInputChange={this.handleUserSearch}
            selectedUsers={contentManager} />

          </div>
          {loadingUsers && <p>候选人员加载中...</p>}
          {usersError && <p className="lr-error">候选人员加载失败，请重试 <button type="button" onClick={this.retryLoadUsers}>重试</button></p>}
          <div className="kb-row">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              确定修改
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const { loc_id } = props;
  const operators = selectors.getTeamRolesOfGroup(
  state,
  loc_id,
  'location_group_operator');

  const manager = selectors.getTeamRolesOfGroup(
  state,
  loc_id,
  'location_group_wechat_manager');

  const contentManager = selectors.getTeamRolesOfGroup(
  state,
  loc_id,
  'location_group_content_manager');

  return {
    operators,
    manager,
    contentManager };

}

const validate = values => {
  const errors = {};
  if (valid.required(values.operator_ids)) {
    errors.operator_ids = '请选择至少一位项目负责人';
  }
  if (valid.required(values.manager_id)) {
    errors.manager_id = '请选择至少一位项目活动负责人';
  }
  if (valid.required(values.content_ids)) {
    errors.content_ids = '请选择至少一位项目内容管理员';
  }
  return errors;
};

const LEGACY_FORM_FIELDS = [
  "operator_ids",
  "manager_id",
  "content_ids"
];

const formConfig = {
  form: 'GroupSettingManageForm',
  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('GroupSettingManageForm', LEGACY_FORM_FIELDS)(GroupSettingManageForm)));
